import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponseModel } from 'src/app/core/services/api/api-response.model';
import { environment } from 'src/environments/environment';
import { CareEventPayload } from '../../dashboard-wearer-summary/care-event.types';
import { DataService } from 'src/app/core/services/api/data.service';

@Injectable({
  providedIn: 'root',
})
export class CareEventService {
  readonly ETECT_STATE_ICONS: Record<string, string> = {
    // dry states
    OK_DRY: 'icon-summary-briefOkay.svg',
    WARNING_DRY: 'icon-summary-briefDryWarning.svg',
    // wet states
    CAUTION_WET: 'icon-summary-briefWetCaution.svg',
    WARNING_WET: 'icon-summary-briefWetWarning.svg',
    // other
    STOPPED: 'icon-summary-briefNotInUse.svg',
    PAUSED: 'icon-summary-briefPaused.svg',
  };

  constructor(private dataService: DataService<ApiResponseModel<any>>) {}

  /**
   * Record care event for a wearer.
   */
  recordCareEvent(
    residentId: string,
    timeZone: string,
    careEventPayload: CareEventPayload
  ): Observable<ApiResponseModel<any>> {
    const url = `${environment.apiUrl.etectrx}${residentId}/recordCareEvent?timeZone=${timeZone}`;
    return this.dataService.post(url, careEventPayload);
  }

  getEtectStateIcon(state: string): string | null {
    if (!state) return null;
    return this.ETECT_STATE_ICONS[state] || null;
  }

  getEtectStateColorClass(state: string): string {
    switch (state) {
      case 'CAUTION_WET':
        return 'caution';
      case 'WARNING_DRY':
      case 'WARNING_WET':
        return 'warning';
      default:
        return '';
    }
  }

  getEtectStateText(state: string): string {
    switch (state) {
      case 'OK_DRY':
      case 'WARNING_DRY':
        return 'Dry';
      case 'CAUTION_WET':
      case 'WARNING_WET':
        return 'Wet';
      case 'STOPPED':
        return 'Not in use';
      case 'PAUSED':
        return 'Monitoring paused';
      default:
        return '';
    }
  }
}
